import { Component, OnInit } from '@angular/core';

import { AppInfoService } from '../services/appInfo/app-info.service';
import { Auth } from '../services/auth.service';
import { AppInfo } from './app-info';

@Component({
  selector: 'appsInfo',
  templateUrl: './appsInfo.component.html',
  styleUrls: ['./appsInfo.component.css']
})
export class AppsInfoComponent implements OnInit {

  apps:AppInfo[];
  newApp: AppInfo = new AppInfo();
  hasSysOpsPermission: Boolean = false;

  constructor(protected appInfoService:AppInfoService,
    protected auth: Auth) {
    this.loadAppsInfo();
  }

  loadAppsInfo() {
    this.appInfoService.get().then(appsInfo => {
      this.apps = appsInfo;
    });
  }

  add() {
    this.appInfoService.create(this.newApp)
      .then(_ => {
        this.loadAppsInfo();
        this.newApp.platform = "";
        this.newApp.currentVersion = "";
        this.newApp.currentBuildNumber = 0;
        this.newApp.minVersion = "";
        this.newApp.minBuildNumber = 0;
      })
      .catch(error => {
        alert("There was an error creating app. Server message: "+ error.message);
      });
  }

  ngOnInit() {
    this.hasSysOpsPermission = this.auth.hasSysOpsPermission();
  }

  onNotify(message:string) {
    if(message=='deleted')
      this.loadAppsInfo();
  }

}



// WEBPACK FOOTER //
// ./src/app/appsInfo/appsInfo.component.ts